import React from 'react';
interface IObjektVyGruppContext {
  menuRef: React.MutableRefObject<HTMLDivElement | null>;
  legendRef: React.MutableRefObject<HTMLDivElement | null>;
}
export const ObjektVyGruppContext = React.createContext<IObjektVyGruppContext>({
  menuRef: React.createRef(),
  legendRef: React.createRef(),
});

export const ObjektVyGruppContextProvider = ObjektVyGruppContext.Provider;
